import React from 'react'
import { Col } from "react-bootstrap"
import { Link } from "react-router-dom"
import "./style.scss";

export default function CardItem({ item, className, year }) {
  return (
    <Col md="3" className={className}>
      <Link
        target={item.target ?? ""}
        to={{
          pathname: item.path,
          state: {fy: year}
        }}
        className="card-body mt-2 text-primary font-weight-bold d-block shadow bg-white rounded text-center pt-5"
        style={{
          height: '12rem',
          marginBottom: '10px',
        }}
      >
        <img
          className="d-inline-block mb-3 icon-program"
          src={item.icon}
          alt=""
          width="50"
        />
        <p>{item.title}</p>
      </Link>
    </Col>
  )
}